import React from 'react';
import PropTypes from 'prop-types';
import MainMenuItem from './mainMenuItem';
const CabinetMenuItem = ({
  identifier,
  title,
  icon: _icon = 'folder-open',
  path,
  showIcons: _showIcons = true
}) => /*#__PURE__*/React.createElement(MainMenuItem, {
  className: `t-h-nav-${identifier}`,
  key: `${identifier}Tab`,
  href: `/#${path}`,
  glyph: _showIcons ? _icon : '',
  title: title
});
CabinetMenuItem.propTypes = {
  identifier: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  path: PropTypes.string.isRequired,
  showIcons: PropTypes.bool
};
export default CabinetMenuItem;